import type { GenerateGeolocationMetadataPayload } from './types';
import type { FulfillmentConfigService } from '.';
import delay from '../mockServiceDelay';

export const mockFulfillmentConfigService: FulfillmentConfigService = {
  fetchZip3Distances: async () => {
    return [];
  },
  generateGeolocationMetadata: async (payload: GenerateGeolocationMetadataPayload) => {
    await delay();
    return {
      latitude: 47.25229,
      longitude: -122.41085,
      timeZoneId: 'America/Los_Angeles',
    };
  },
  fetchCarrierSchedules: async (partnerId: string) => {
    return [];
  },
};
export default mockFulfillmentConfigService;
